import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { HvlFormGroup } from '@hvlng/framework-bff/core';

export class KovanFormGroup<T> extends HvlFormGroup<T> {
    constructor(model: T) {
        super(model);
    }

    get typed(): FormGroup<TypedControl<T>> {
        return this as unknown as FormGroup<TypedControl<T>>;
    }
}

export interface NoControl {
    _noControl?: boolean;
}
export interface SimpleControl {
    _simpleControl?: boolean;
}

export type TypedControl<TModel> = {
    [Property in keyof TModel]: TModel[Property] extends NoControl
        ? never
        : TModel[Property] extends SimpleControl
          ? FormControl<TModel[Property]>
          : TModel[Property] extends any[]
            ? FormArray<FormGroup<TypedControl<TModel[Property][number]>>>
            : TModel[Property] extends BasicType
              ? FormControl<TModel[Property]>
              : FormGroup<TypedControl<TModel[Property]>>;
};

type BasicType = string | number | Date | Map<any, any> | boolean;
